import React from 'react';

import type { FlagProps } from '../src/types';

const FlagTm = ({ className, testID }: FlagProps) => (
  <svg
    width={20}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testID}
    className={className}
    aria-hidden="true"
  >
    <mask
      id="prefix__a"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={15}
    >
      <path fill="#fff" d="M0 0h20v15H0z" />
    </mask>
    <g mask="url(#prefix__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0v15h20V0H0z"
        fill="#29C470"
      />
      <mask
        id="prefix__b"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={20}
        height={15}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#prefix__b)">
        <path fill="#C51918" d="M1.25-.202H7.5V16.25H1.25z" />
        <mask
          id="prefix__c"
          maskUnits="userSpaceOnUse"
          x={1}
          y={-1}
          width={7}
          height={18}
        >
          <path fill="#fff" d="M1.25-.202H7.5V16.25H1.25z" />
        </mask>
        <g mask="url(#prefix__c)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m1.622.566-.341.439-.031-.03.331-.426V.463l.001-.008.039-.118-.024-.042-.195.196.376-.587v.2l.073.066.172-.302-.173-.29-.125.096.05.102-.034.024-.282-.472.18.123.031-.046-.172-.176.076-.083-.251-.368.032-.028.274.4-.071.078.168.171-.077.113-.052-.036.098.165.166-.128.211.355-.211.37-.123-.111v-.08l-.124.192.052.092-.044.136v.099zm-.341 3.578.341-.439v-.098l.044-.137-.052-.091.124-.193v.08l.123.111.211-.37-.21-.354-.167.127-.098-.164.052.035.077-.112-.168-.172.071-.078-.274-.4-.032.029.251.367-.076.084.172.175-.031.046-.18-.123.282.472.035-.024-.05-.102.124-.096.173.29-.172.302-.073-.065v-.2l-.376.586.195-.195.024.041-.039.119v.093l-.332.425.03.03zm.341 2.424-.341.438-.031-.03.331-.426v-.085l.001-.008.039-.119-.024-.04-.195.194.376-.586v.2l.073.066.172-.302-.173-.29-.125.095.05.102-.034.024-.282-.472.18.123.031-.046-.172-.175.076-.084-.251-.367.032-.028.274.4-.071.078.168.17-.077.113-.052-.035.098.164.166-.127.211.354-.211.37-.123-.11v-.08l-.124.192.052.092-.044.136v.099zm-.341 3.347.341-.439v-.099l.044-.136-.052-.092.124-.192v.08l.123.111.211-.37-.21-.354-.167.127-.098-.165.052.036.077-.113-.168-.17.071-.08-.274-.399-.032.028.251.368-.076.084.172.175-.031.046-.18-.123.282.472.035-.024-.05-.102.124-.096.173.29-.172.302-.073-.065v-.2l-.376.586.195-.195.024.04-.039.12v.093l-.332.425.03.03zm0 2.585.341-.439v-.098l.044-.136-.052-.092.124-.193v.08l.123.111.211-.37-.21-.354-.167.127-.098-.164.052.035.077-.112-.168-.171.071-.079-.274-.4-.032.029.251.367-.076.084.172.175-.031.046-.18-.123.282.472.035-.024-.05-.102.124-.096.173.29-.172.302-.073-.065v-.2l-.376.586.195-.195.024.041-.039.119v.093l-.332.426.03.03zm6.188 0-.341-.439v-.098l-.044-.136.052-.092-.124-.193v.08l-.123.111-.211-.37.21-.354.167.127.098-.164-.052.035-.077-.112.168-.171-.071-.079.274-.4.032.029-.251.367.076.084-.172.175.031.046.18-.123-.282.472-.035-.024.05-.102-.124-.096-.173.29.172.302.073-.065v-.2l.376.586-.195-.195-.024.041.039.119v.093l.332.426-.03.03zm-.341-3.024.341.439.031-.03-.331-.426v-.086l-.001-.008-.039-.118.024-.041.195.195-.376-.586v.2l-.073.065-.172-.302.173-.29.125.096-.05.102.034.024.282-.472-.18.123-.031-.046.172-.175-.076-.084.251-.368-.032-.028-.274.4.071.078-.168.171.077.113.052-.036-.098.165-.166-.127-.211.354.211.37.123-.111v-.08l.124.192-.052.092.044.136v.1zm.341-2.47-.341-.438v-.1l-.044-.135.052-.092-.124-.192v.08l-.123.11-.211-.37.21-.354.167.127.098-.164-.052.035-.077-.112.168-.171-.071-.079.274-.4.032.029-.251.367.076.084-.172.175.031.046.18-.123-.282.472-.035-.024.05-.102L6.9 5.58l-.173.29.172.303.073-.066v-.2l.376.586-.195-.195-.024.041.039.119v.093l.332.426-.03.03zm-.341-3.3.341.438.031-.03-.331-.426v-.085l-.001-.008-.039-.119.024-.041.195.195-.376-.586v.2l-.073.065-.172-.302.173-.29.125.096-.05.102.034.024.282-.472-.18.123-.031-.046.172-.175-.076-.084.251-.367-.032-.029-.274.4.071.078-.168.172.077.112.052-.035-.098.164-.166-.127-.211.354.211.37.123-.11v-.08l.124.192-.052.091.044.137v.098zm.341-2.701L7.128.566V.467L7.084.331 7.136.24 7.012.047v.08L6.89.238l-.211-.37.21-.355.167.128.098-.165-.052.036-.077-.113.168-.17-.071-.08.274-.399.032.028-.251.368.076.083-.172.176.031.046.18-.123L7.01-.2l-.035-.024.05-.102L6.9-.422l-.173.29.172.302.073-.065v-.2l.376.586-.195-.196-.024.042.039.118V.55L7.5.974l-.03.03z"
            fill="#E8AA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.567 9.103h.97v.228h.222v.182h.265v.592H5.76v.183h-.221v.182h-.945l-.262.232-.263-.232h-.876v-.182h-.22v-.183H2.75v-.592h.221v-.182h.221v-.228h.902l.237-.21.236.21z"
            fill="#389F5D"
          />
          <path
            d="M5.538 9.103h.25v-.25h-.25v.25zm-.971 0L4.4 9.29l.07.063h.096v-.25zm.97.228h-.25v.25h.25v-.25zm.222 0h.25v-.25h-.25v.25zm0 .182h-.25v.25h.25v-.25zm.265 0h.25v-.25h-.25v.25zm0 .592v.25h.25v-.25h-.25zm-.265 0v-.25h-.25v.25h.25zm0 .183v.25h.25v-.25h-.25zm-.221 0v-.25h-.25v.25h.25zm0 .182v.25h.25v-.25h-.25zm-.945 0v-.25h-.095l-.072.063.167.187zm-.262.232-.166.188.167.146.165-.147-.166-.187zm-.263-.232.166-.187-.07-.063h-.096v.25zm-.876 0h-.25v.25h.25v-.25zm0-.182h.25v-.25h-.25v.25zm-.22 0h-.25v.25h.25v-.25zm0-.183h.25v-.25h-.25v.25zm-.222 0H2.5v.25h.25v-.25zm0-.592v-.25H2.5v.25h.25zm.221 0v.25h.25v-.25h-.25zm0-.182v-.25h-.25v.25h.25zm.221 0v.25h.25v-.25h-.25zm0-.228v-.25h-.25v.25h.25zm.902 0v.25h.095l.071-.063-.166-.187zm.237-.21.166-.186-.165-.148-.167.147.166.187zm1.207-.04h-.971v.5h.97v-.5zm.25.478v-.228h-.5v.228h.5zm-.03-.25h-.22v.5h.22v-.5zm.25.432v-.182h-.5v.182h.5zm.016-.25H5.76v.5h.265v-.5zm.25.842v-.592h-.5v.592h.5zm-.515.25h.265v-.5H5.76v.5zm.25-.067v-.183h-.5v.183h.5zm-.471.25h.22v-.5h-.22v.5zm.25-.068v-.182h-.5v.182h.5zm-1.195.25h.945v-.5h-.945v.5zm-.096.17.262-.233-.333-.374-.261.232.332.374zm-.594-.233.262.233.332-.375-.263-.232-.331.374zm-.71.063h.875v-.5h-.876v.5zm-.25-.432v.182h.5v-.182h-.5zm.028.25h.221v-.5h-.22v.5zm-.25-.433v.183h.5v-.183h-.5zm.029.25h.221v-.5H2.75v.5zm-.25-.842v.592H3v-.592h-.5zm.471-.25H2.75v.5h.221v-.5zm-.25.068v.182h.5v-.182h-.5zm.471-.25h-.22v.5h.22v-.5zm-.25.022v.228h.5v-.228h-.5zm1.152-.25h-.902v.5h.902v-.5zm.166.437.237-.21-.332-.374-.236.21.331.374zm-.095-.21.236.21.332-.374-.236-.21-.332.374z"
            fill="#E8AA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.322 9.63v-.403h.47l-.47.403zm1.974 0v-.403h-.47l.47.403zm-1.974.729v-.403l.47.403h-.47zm1.974-.403v.403h-.47l.47-.403z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m4.153 9.262.162-.212.16.212h-.322zm0 .198.162.212.16-.212h-.322zm.162.501-.162.212h.322l-.16-.212zm-.162.41.162.212.16-.212h-.322z"
            fill="#E8AA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.157 9.236v.092h-.093v.125h.093v.09h.324v-.09h.093v-.125H4.48v-.092h-.324zm.324 1.003v-.091h-.324v.091h-.093v.125h.093v.091h.324v-.09h.093v-.126H4.48zm-.947-.521.154-.213.152.213h-.306zm0 .2.154.212.152-.213h-.306zm1.437-.413-.154.213h.306l-.152-.213zm-.154.412.154.213.152-.213h-.306z"
            fill="#AF0100"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.533 9.692v.093h-.089v.128h.089v.093h.308v-.093h.089v-.128h-.09v-.093h-.308zm1.592.093v-.093h-.31v.093h-.088v.128h.089v.093h.309v-.093h.088v-.128h-.088z"
            fill="#E8AA00"
          />
          <mask
            id="prefix__d"
            maskUnits="userSpaceOnUse"
            x={2}
            y={10}
            width={5}
            height={4}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="m3.886 10.782-1.108.624v1.035l1.108.65h1.199l1.133-.65v-1.035l-1.133-.624h-1.2z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#prefix__d)">
            <path d="M2.794 11.935H4.52v1.14H2.794v-1.14z" fill="#E8AA00" />
            <path fill="#F9E8E7" d="M2.617 10.796H4.52v1.139H2.617z" />
            <path
              d="m3.06 11.46.573-.345v.345H3.06zm3.363-.664H4.52v1.139h1.903z"
              fill="#E8AA00"
            />
            <path
              d="m5.847 11.46-.572-.345v.345h.572zm.398 1.614H4.52v-1.139h1.726z"
              fill="#F9E8E7"
            />
            <path d="m5.803 12.41-.573.345v-.345h.573z" fill="#E8AA00" />
            <path d="m3.06 12.338.573.345v-.345H3.06z" fill="#FCFCFC" />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.9 11.48h.288l.288-.092.287.091h.288v.866h-.288l-.287.137-.288-.137H3.9v-.866z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.874 10.961h.156v.176h.064v.125H5.03v.068h-.156v-.369zm-1.57.547h-.156v.369h.156v-.068h.065v-.125h-.065v-.176zm.222 0h-.157v.369h.157v-.37zm-.222.456h-.156v.368h.156v-.067h.065v-.125h-.065v-.176zm.065 0h.157v.368h-.157v-.368zm2.213-.456h.156v.176h.064v.125h-.064v.068h-.156v-.37zm.377 0h-.156v.369h.156v-.37zm-.22.456h-.157v.368h.156v-.067h.064v-.125h-.064v-.176zm.064 0h.156v.368h-.156v-.368zm-.552-1.003h-.156v.369h.156v-.369zm-1.283 0h-.156v.369h.156v-.068h.064v-.125h-.064v-.176zm.065 0h.156v.369h-.156v-.369zm.84 1.55h.157v.176h.064v.125H5.03v.067h-.156v-.368zm.378 0h-.156v.368h.156v-.368zm-1.283 0h-.156v.368h.156v-.067h.064v-.125h-.064v-.176zm.065 0h.156v.368h-.156v-.368z"
            fill="#C9343F"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.39 11.666h.045v-.123h-.221v.141h-.182v.203h.17v-.045h-.126v-.112h.15l.226.195-.226.196h-.15v-.112H4.2v-.045h-.17v.203h.183v.141h.22v-.123H4.39v.078h-.133v-.11l.23-.199.23.2v.109h-.132v-.079H4.54v.124h.221v-.141h.183v-.203h-.17v.045H4.9v.112h-.15l-.226-.196.226-.195h.15v.112h-.125v.045h.17v-.203h-.183v-.141h-.22v.123h.044v-.078h.132v.11l-.23.199-.23-.2v-.109h.133v.078z"
            fill="#fff"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.74 3h-.779v2.5h.78V3zm-1.753.529h.487v1.346h-.487V3.529zm2.289 0h.487v1.346h-.487V3.529z"
            fill="#E8AA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.961 3.192h-.487v1.923h.487V3.192zm-.974.53H2.5v.913h.487V3.72zm2.776 0h.487v.913h-.487V3.72zm-.536-.53H4.74v1.923h.487V3.192z"
            fill="#389F5D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.864 3.433c0 .08-.066.144-.146.144a.145.145 0 0 1-.147-.144c0-.08.066-.145.147-.145.08 0 .146.065.146.145zm-.974.48c0 .08-.066.145-.147.145a.145.145 0 0 1-.146-.145c0-.08.066-.144.147-.144.08 0 .146.065.146.144zm0 .53a.146.146 0 0 1-.147.144.145.145 0 0 1-.146-.145c0-.08.066-.144.147-.144.08 0 .146.065.146.144zm.828.576c.08 0 .146-.064.146-.144a.145.145 0 0 0-.146-.144.145.145 0 0 0-.147.144c0 .08.066.144.147.144zm2.288-.961a.146.146 0 0 0 .147-.145.145.145 0 0 0-.147-.144.145.145 0 0 0-.146.144c0 .08.066.145.146.145zm.147.384c0 .08-.066.145-.147.145a.145.145 0 0 1-.146-.145c0-.08.066-.144.146-.144.081 0 .147.065.147.144zm-1.17.577a.145.145 0 0 0 .147-.144.145.145 0 0 0-.146-.144.145.145 0 0 0-.146.144c0 .08.065.144.146.144zm.147-1.586c0 .08-.066.144-.146.144a.145.145 0 0 1-.146-.144.146.146 0 0 1 .292 0z"
            fill="#E1E5E8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.497 3.24c0 .08-.066.145-.146.145a.145.145 0 0 1-.146-.145c0-.08.065-.144.146-.144.08 0 .146.065.146.144zm-1.12.53a.145.145 0 0 1-.146.143.145.145 0 0 1-.147-.144c0-.08.066-.144.147-.144.08 0 .146.065.146.144zm.974 1.682c.08 0 .146-.065.146-.144a.145.145 0 0 0-.146-.145.145.145 0 0 0-.146.145c0 .08.065.144.146.144zm1.315-1.683c0 .08-.066.144-.147.144a.145.145 0 0 1-.146-.144c0-.08.066-.144.146-.144.081 0 .147.065.147.144zM3.23 4.78c.08 0 .146-.065.146-.144a.145.145 0 0 0-.146-.145.145.145 0 0 0-.147.145c0 .08.066.144.147.144zm2.435-.144c0 .08-.066.144-.147.144a.145.145 0 0 1-.146-.144c0-.08.066-.145.146-.145.081 0 .147.065.147.145z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m3.504 3.995.474-.429h.77l.54.492h.718v.192h-.698v.01l-.56.57h-.77l-.474-.514V4.25h-.81v-.192h.81v-.063z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m4.382 3.923.23.233-.242.23-.241-.23.23-.233.011-.01.012.01zm.042.563.027-.025-.028-.026.24-.227.25.253-.112.12h-.067l-.124.077-.186-.172zm-.054.05-.23.213-.154-.097h-.078l-.181-.192.298-.302-.3-.285.197-.191.071.056.104-.104-.032-.032.053-.05.252.256.253-.256.052.05-.03.032.103.104.071-.056.197.191-.3.285.298.302-.182.192h-.077l-.154.097-.23-.213zm.13-.598.002-.003-.069-.064-.009-.009.18-.166.138.139.072-.057.097.095-.246.233-.166-.168zm-.155.523-.214.197-.124-.078H3.94l-.112-.119.25-.253.267.253zm-.516-.588.247.233.24-.244-.18-.166L4 3.835l-.072-.057-.098.095zM2.78 13.401c-.13-.166-.219-.278-.242-.276-.073.005-.141.777.807 1.365 0 0 .14.078.221 0 .082-.078 0-.193 0-.193-.306-.287-.593-.65-.786-.896zm3.19 0c.13-.166.219-.278.242-.276.073.005.141.777-.807 1.365 0 0-.14.078-.221 0-.082-.078 0-.193 0-.193.306-.287.593-.65.786-.896zM5.9 14.44c-.311.092-.672.111-.81.052a.793.793 0 0 0-.14-.045 1.258 1.258 0 0 0-.43-.014l-.058.006h-.004a.416.416 0 0 1-.025.003c-.01 0-.02.002-.03.004a.137.137 0 0 0-.031-.004l-.026-.002h-.003l-.06-.007a1.258 1.258 0 0 0-.429.014.793.793 0 0 0-.14.045c-.138.06-.498.04-.81-.052 0 0 .567.227.904.127a.586.586 0 0 1 .103-.034.969.969 0 0 1 .312-.012 3.66 3.66 0 0 1-.175.076v.028c.133-.054.288-.08.354-.087a1.5 1.5 0 0 1 .354.087v-.028a3.664 3.664 0 0 1-.174-.076.969.969 0 0 1 .312.012c.036.008.07.02.103.034.337.1.903-.127.903-.127z"
            fill="#E8AA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m3.602 6.236-.782.69v.656l.684.688h1.397l.77-.734v-.559l-.77-.741H3.602z"
            fill="#389F5D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.872 6.309h-.177v.137h.177v-.137zm0 1.787h-.177v.137h.177v-.137zm.265 0h.177v.137h-.177v-.137zm.177-1.787h-.177v.137h.177v-.137zm.266 1.787h.177v.137H4.58v-.137zm.177-1.787H4.58v.137h.177v-.137z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.096 6.273h-.18v.137h.18v-.137zm0 1.823h-.18v.137h.18v-.137zm.27-1.823h.18v.137h-.18v-.137zm.18 1.823h-.18v.137h.18v-.137z"
            fill="#E8AA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.071 6.151h2.363v.365h.338v1.51h-.338v.312H3.07v-.312h-.367v-1.51h.367v-.365zm.133.502h-.368v1.236h.368V8.2H5.3v-.312h.338V6.653H5.3v-.365H3.204v.365z"
            fill="#750100"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.004 6h-.22v.228h.22V6zm.354 0h-.22v.228h.22V6zm.133 0h.221v.228h-.22V6zm-.487 2.279h-.22v.228h.22v-.228zm.133 0h.221v.228h-.22v-.228zm.575 0h-.22v.228h.22v-.228zm-2.215-.505v-.221h.228v.221h-.228zm0-.586v.221h.228v-.22h-.228zm0-.143v-.221h.228v.22h-.228zm3.186.508v.221h.227v-.221h-.227zm0-.144v-.22h.227v.22h-.227zm0-.585v.22h.227v-.22h-.227z"
            fill="#389F5D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m3.611 6.428-.381.332v1.074l.317.224h1.372l.317-.224V6.76l-.357-.332H3.61z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m4.252 6.873-.46.393h.46v-.393z"
            fill="#E1E5E8"
          />
          <path d="m4.252 7.623-.46-.393h.46v.393z" fill="#E8AA00" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m4.212 6.873.46.393h-.46v-.393z"
            fill="#E8AA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.232 7.373a.14.14 0 1 0 0-.28.14.14 0 0 0 0 .28z"
            fill="#29AE66"
          />
          <path d="m4.212 7.623.46-.393h-.46v.393z" fill="#E1E5E8" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.252 7.094h-.398v.127h.398v-.127zm0 .232h-.398v.128h.398v-.128zm1.991-.232h.399v.127h-.399v-.127zm.399.232h-.399v.128h.399v-.128z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.208 6.957h-.354v.14h.354v-.14zm0 .232h-.354v.14h.354v-.14zm-.354.233h.354v.14h-.354v-.14zm2.743-.465h-.354v.14h.354v-.14zm-.354.232h.354v.14h-.354v-.14zm.354.233h-.354v.14h.354v-.14zM6.24.994v.253H4.39l-.001 1.15h-.58c-.101 0-.379-.194-.379-.194h-.47l-.218-.222v-.223l-.234-.277.002-.254h1.85V.077h.58c.102 0 .38.195.38.195h.47l.217.222v.223l.234.277z"
            fill="#E8AA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m2.508.994.002.253h1.85v1.15h.58c.102 0 .38-.194.38-.194h.47l.217-.222v-.223l.234-.277-.002-.254H4.39V.077h-.58c-.101 0-.379.195-.379.195h-.47l-.218.222v.223l-.234.277z"
            fill="#E1E5E8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m3.751.428-.02-.097.399-.092a1.29 1.29 0 0 0 .245-.196l.054.06.01-.01c.114.107.197.173.245.196l.399.092-.02.097L4.84.433l.021.019a.275.275 0 0 0-.05.04l-.09-.015.008-.032-.023-.004a1.062 1.062 0 0 0-.058.138L4.554.553 4.59.372 4.38.174l-.149.138a.61.61 0 0 1 .055.058.877.877 0 0 1-.045.016l-.006.001.024.116-.093.027a1.4 1.4 0 0 0-.035-.09l-.008.001a.275.275 0 0 0-.05-.04L4.1.378a.235.235 0 0 0-.012-.02l-.338.07zm.017.358L3.82.703 3.546.518l.03-.043-.078-.059-.034.047-.11-.073-.053.084.105.07-.021.03.078.06.025-.035.28.187zm-.341.1L3.48.803 3.205.618l.03-.043-.078-.059-.034.047-.11-.073-.053.084.105.07-.021.03.078.06.025-.035.28.187zm-.146.3.053-.083-.275-.185.03-.043-.078-.059-.034.047-.11-.073-.053.084.105.07-.021.03.078.06.025-.035.28.187zm.004.24-.053-.083-.28.187-.025-.034-.078.059.021.03-.104.07.053.084.11-.073.033.047.078-.059-.03-.043.275-.185zm.093.217.053.083-.275.185.03.043-.078.06-.034-.048-.11.073-.052-.083.105-.07-.022-.031.078-.06.025.035.28-.187zm.341.1.053.083-.275.185.03.043-.078.06-.034-.048-.11.073-.052-.083.104-.07-.021-.031.078-.06.025.035.28-.187zm.52.478a.878.878 0 0 0-.045-.016L4.175 2.2l.037-.174L4.118 2a.754.754 0 0 1-.078.172l-.337-.07-.02.098.384.088.055.037.008-.004c.048.034.114.09.197.166l.031-.035.032.035a1.29 1.29 0 0 1 .245-.196l.013-.003a.387.387 0 0 0 .05.037l.056-.037-.005-.019.006-.005.279-.064-.02-.098-.338.07A.753.753 0 0 1 4.598 2l-.093.027.038.181-.185.173-.142-.133a.702.702 0 0 0 .023-.026zm1.192-.795.053-.083.28.187.025-.034.079.059-.022.03.105.07-.053.084-.11-.073-.034.047-.078-.059.03-.043-.275-.185zm-.146.3.053-.083.28.187.025-.034.079.059-.022.03.105.07-.053.084-.11-.073-.034.047-.078-.059.03-.043-.275-.185zm-.34.1.052-.083.28.187.025-.034.079.059-.022.03.105.07-.053.084-.11-.073-.034.047-.078-.059.03-.043-.275-.185zm.535-.673.053.083.28-.187.025.034.078-.059-.021-.03L6 .924 5.946.84l-.109.073-.034-.047-.078.06.03.042-.275.185zm-.146-.3.053.083.28-.187.025.034.078-.059-.021-.03.104-.07L5.8.54l-.11.073-.033-.047-.078.06.03.042-.275.185zm-.341-.1.053.083.28-.187.025.034.078-.059-.021-.03.105-.07L5.459.44 5.35.513 5.316.466l-.078.06.03.042-.275.185z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m3.88.72.55-.291v.8h1.364l-.325.234v.306h-.514l-.552.293v-.8H3.041l.324-.234V.72h.515z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.956.72 4.404.429v.8H3.041l.324.234v.306h.515l.551.293v-.8h1.364l-.325-.234V.72h-.514z"
            fill="#29AE66"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m3.612.928.09-.177.229.122.063-.094.16.114-.05.073.679.363.041-.063.16.114-.027.042.073.039-.09.177-.095-.05-.077.114-.16-.114.063-.094-.678-.362-.055.083-.16-.114.041-.062-.207-.111z"
            fill="#29AE66"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.056.88 4.954.707l-.22.139-.07-.09-.151.125.054.07-.65.409-.047-.06-.152.125.03.04-.07.044.103.17.09-.057.085.109.152-.125-.07-.089.652-.409.06.079.153-.125-.046-.059.199-.125z"
            fill="#C51918"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.92 1.25s1.457 3.451.163 4.917C10.79 7.632 7.5 7.35 7.5 7.35s4.223 1.907 6.063-.72c1.84-2.626-1.642-5.38-1.642-5.38z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m9.278 3.28-.386.272.136-.455-.374-.287.47-.01.154-.448.154.448.47.01-.375.287.136.455-.385-.272zm.074 1.254-.385.27.136-.454-.374-.287.47-.01.153-.448.154.449.47.01-.374.286.136.455-.386-.271zm-1.557.368.386-.272.385.272-.136-.455.374-.287-.47-.01-.153-.448-.154.449-.47.01.374.286-.136.455zm1.557.946-.385.272.136-.455-.374-.287.47-.01.153-.448.154.448.47.01-.374.287.136.455-.386-.272zm.888-1.426.386-.271.385.27-.136-.454.374-.287-.47-.01-.153-.448-.154.449-.47.01.374.286-.136.455z"
          fill="#F7FCFF"
        />
      </g>
    </g>
  </svg>
);

export default FlagTm;
